// src/components/TZMMS-INV/TZMMSInvPage.jsx
// ============================================================================
// BLOCK TZI.PAGE.001 — TZMMS Inventory Counter route wrapper
// ----------------------------------------------------------------------------
// PURPOSE
// - Provides the route-level entry component for the TZMMS-INV feature.
// - Keeps the feature self-contained inside the TZMMS-INV component folder.
// - Allows AppContent.jsx to mount the feature without needing a separate
//   page file under src/pages.
// ============================================================================

import React from 'react';
import { useAuth0 } from '@auth0/auth0-react';

import TZMMSInv from './TZMMSInv.jsx';

function TZMMSInvPage() {
  const { user } = useAuth0();
  return <TZMMSInv userEmail={user?.email ?? ''} />;
}

export default React.memo(TZMMSInvPage);
